import PropTypes from 'prop-types';

// matches values in https://formik.org/docs/api/formik#props-1

export const formikPropTypes = PropTypes.shape({
  errors: PropTypes.shape({}).isRequired,
  handleChange: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  setStatus: PropTypes.func.isRequired,
  status: PropTypes.shape({}),
  touched: PropTypes.shape({}).isRequired,
  values: PropTypes.shape({}).isRequired,
});

// used for unit tests with the above formikPropTypes
export const formikProps = {
  errors: {},
  handleChange: () => {},
  setStatus: () => {},
  // formik does not initialize status with anything
  status: null,
  touched: {},
  values: {},
};

export default formikPropTypes;
